import API from 'shared/constants/api';

import { execPostRequest } from '../leasing/utils';

export const addSuggestion = async (params, fetch) => {
  const { carLocation, userName, phone, advert } = params;

  const data = {
    fullName: userName,
    carLocation,
    phone,
    transport: advert.transport ? advert.transport.title : '',
    partTitle: !advert.transport ? advert.title || '' : '',
    is_new: !!advert.is_new,
    make: (advert.make && advert.make.title) || '',
    model: (advert.model && advert.model.title) || '',
    year: advert.year,
  };
  return execPostRequest(API.ADVERT.SUGGESTION.ADD_SUGGESTION, data, fetch, {}, 'addSuggestion');
};

export const createSuggestion = async (params, advert, fetch) => {
  let result = null;

  try {
    console.log(advert);
    result = await addSuggestion(params, fetch);
    if (!result || !result.id) throw Error('addSuggestion error');
  } catch (e) {
    console.error(e);
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/suggest/suggest.js